export default __webpack_public_path__ + "static/media/Figurado.1870d564.png";